/**
 * Sprint TF-1 Phase 1 — Status / Stage / Scope badges.
 * Pure UI helpers reused by ClientTalentFix and AdminTalentFix.
 */
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { useTranslation } from 'react-i18next';
import { Clock, CheckCircle2, XCircle, Pause, ShieldCheck, Lock, Eye, EyeOff } from 'lucide-react';

const STATUS_META = {
  pending:     { icon: Clock,        cls: 'bg-warning/15 text-warning border-warning/30' },
  accepted:    { icon: CheckCircle2, cls: 'bg-success/15 text-success border-success/30' },
  in_progress: { icon: CheckCircle2, cls: 'bg-info/15 text-info border-info/30' },
  declined:    { icon: XCircle,      cls: 'bg-destructive/15 text-destructive border-destructive/30' },
  closed:      { icon: Pause,        cls: 'bg-muted text-foreground border-border' },
};

const SCOPE_C_META = {
  standard:   { icon: Eye,         cls: 'bg-muted text-foreground' },
  restricted: { icon: EyeOff,      cls: 'bg-warning/10 text-warning border-warning/30' },
  privileged: { icon: ShieldCheck, cls: 'bg-purple-500/10 text-purple-700 border-purple-500/30' },
  legal_hold: { icon: Lock,        cls: 'bg-destructive/10 text-destructive border-destructive/30' },
};

export function CaseStatusBadge({ status }) {
  const { t } = useTranslation();
  const meta = STATUS_META[status] || STATUS_META.pending;
  const Icon = meta.icon;
  return (
    <Badge className={`gap-1 ${meta.cls}`} data-testid={`tf-status-${status}`}>
      <Icon className="h-3 w-3" />
      {t(`talentFix.status.${status}`)}
    </Badge>
  );
}

export function CaseScopeBadge({ scope }) {
  const { t } = useTranslation();
  const meta = SCOPE_C_META[scope] || SCOPE_C_META.standard;
  const Icon = meta.icon;
  return (
    <Badge className={`gap-1 ${meta.cls}`} data-testid={`tf-scope-${scope}`}>
      <Icon className="h-3 w-3" />
      {t(`talentFix.scopeC.${scope}`)}
    </Badge>
  );
}

export function CaseOriginPill({ origin }) {
  const { t } = useTranslation();
  return (
    <span className="text-xs uppercase tracking-wider font-semibold text-muted-foreground" data-testid={`tf-origin-pill-${origin}`}>
      {t(`talentFix.origin.${origin}`)}
    </span>
  );
}
